/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Members_DeniedInputs */

const th_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เฉพาะเจ้าขององค์กรหรือผู้ดูแลเท่านั้นที่ดูและจัดการสมาชิกได้`)
};

const en_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only an owner or admin of this organisation can see and manage its members.`)
};

const ja_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この団体のメンバーを表示・管理できるのは、オーナーまたは管理者のみです。`)
};

const zh_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只有该组织的所有者或管理员才能查看和管理其成员。`)
};

const es_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo un propietario o administrador de esta organización puede ver y gestionar a sus miembros.`)
};

const pt_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só um proprietário ou administrador desta organização pode ver e gerenciar seus membros.`)
};

const id_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya pemilik atau administrator organisasi ini yang bisa melihat dan mengelola anggotanya.`)
};

const fr_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seul un propriétaire ou un administrateur de cette organisation peut voir et gérer ses membres.`)
};

const tl_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang may-ari o administrador lamang ng organisasyong ito ang makakakita at makapamamahala sa mga miyembro nito.`)
};

const vi_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ chủ sở hữu hoặc quản trị viên của tổ chức này mới xem và quản lý được thành viên.`)
};

const ko_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 조직의 소유자나 관리자만 구성원을 보고 관리할 수 있습니다.`)
};

const de_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur ein Eigentümer oder Administrator dieser Organisation kann ihre Mitglieder sehen und verwalten.`)
};

const ru_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видеть участников этой организации и управлять ими может только её владелец или администратор.`)
};

const tr_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu kuruluşun üyelerini yalnızca sahibi ya da yöneticisi görebilir ve yönetebilir.`)
};

const it_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo un proprietario o un amministratore di questa organizzazione può vederne e gestirne i membri.`)
};

const pl_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tylko właściciel albo administrator tej organizacji może widzieć jej członków i nimi zarządzać.`)
};

const uk_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бачити учасників цієї організації та керувати ними може лише її власник або адміністратор.`)
};

const hi_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस संगठन के सदस्यों को केवल इसका स्वामी या व्यवस्थापक देख और प्रबंधित कर सकता है।`)
};

const ar_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يرى أعضاء هذه المؤسسة ويديرهم إلا مالكها أو مشرفها.`)
};

const ms_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya pemilik atau pentadbir organisasi ini boleh melihat dan mengurus ahlinya.`)
};

const bn_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই সংস্থার সদস্যদের কেবল এর মালিক বা প্রশাসক দেখতে ও পরিচালনা করতে পারেন।`)
};

const zh_tw2_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只有這個組織的擁有者或管理者才能查看與管理其成員。`)
};

const zh_hk2_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只有這個組織的擁有者或管理者才能查看與管理其成員。`)
};

const ur_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس ادارے کے ارکان صرف اس کا مالک یا منتظم دیکھ اور سنبھال سکتا ہے۔`)
};

const fa_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنها مالک یا مدیر این سازمان می‌تواند اعضایش را ببیند و اداره کند.`)
};

const sw_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ni mmiliki au msimamizi wa shirika hili pekee anayeweza kuona na kusimamia wanachama wake.`)
};

const nl_org_members_denied = /** @type {(inputs: Org_Members_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleen een eigenaar of beheerder van deze organisatie kan haar leden zien en beheren.`)
};

/**
* | output |
* | --- |
* | "Only an owner or admin of this organisation can see and manage its members." |
*
* @param {Org_Members_DeniedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const org_members_denied = /** @type {((inputs?: Org_Members_DeniedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Members_DeniedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_org_members_denied(inputs)
	if (locale === "ja") return ja_org_members_denied(inputs)
	if (locale === "zh") return zh_org_members_denied(inputs)
	if (locale === "es") return es_org_members_denied(inputs)
	if (locale === "pt") return pt_org_members_denied(inputs)
	if (locale === "id") return id_org_members_denied(inputs)
	if (locale === "fr") return fr_org_members_denied(inputs)
	if (locale === "tl") return tl_org_members_denied(inputs)
	if (locale === "vi") return vi_org_members_denied(inputs)
	if (locale === "ko") return ko_org_members_denied(inputs)
	if (locale === "de") return de_org_members_denied(inputs)
	if (locale === "ru") return ru_org_members_denied(inputs)
	if (locale === "tr") return tr_org_members_denied(inputs)
	if (locale === "it") return it_org_members_denied(inputs)
	if (locale === "pl") return pl_org_members_denied(inputs)
	if (locale === "uk") return uk_org_members_denied(inputs)
	if (locale === "hi") return hi_org_members_denied(inputs)
	if (locale === "ar") return ar_org_members_denied(inputs)
	if (locale === "ms") return ms_org_members_denied(inputs)
	if (locale === "bn") return bn_org_members_denied(inputs)
	if (locale === "zh-TW") return zh_tw2_org_members_denied(inputs)
	if (locale === "zh-HK") return zh_hk2_org_members_denied(inputs)
	if (locale === "ur") return ur_org_members_denied(inputs)
	if (locale === "fa") return fa_org_members_denied(inputs)
	if (locale === "sw") return sw_org_members_denied(inputs)
	if (locale === "nl") return nl_org_members_denied(inputs)
	return en_org_members_denied(inputs)
});